<template>
  <paginateTable
    :headers="headers"
    :gets="get"
    name="paginated_action_tracker_issues"
    :preFilters.sync="preFilters">

      <template slot-scope="{ props }" slot="items">
				<tr style="vertical-align: top;">
          <td style="text-align:left !important;padding-left:4px !important"><fs1-span>{{ props.item.organization_name }}</fs1-span></td>
          <td style="text-align:left !important;padding-left:4px !important"><fs1-span>{{ props.item.functional_location }}</fs1-span></td>
          <td style="text-align:left !important;padding-left:4px !important"><fs1-span>{{ props.item.dsc }}</fs1-span></td>
          <template v-if="table_type == 'ReportTable'">
            <fs1 tag="td">{{props.item.main_group_centre}}</fs1>
            <fs1 tag="td">{{props.item.work_order_number}}</fs1>
            <fs1 tag="td">{{props.item.wo_description}}</fs1>
          </template>
          <td v-if="findV('pwo_with_detail')"><fs1-span>{{ props.item.pwo_with_detail }}</fs1-span></td>
          <td v-if="findV('pwo_total')"><fs1-span>{{ props.item.pwo_total }}</fs1-span></td>
				</tr>
        
      </template>
    </paginateTable>
</template>

<script>
import paginateTable from '@/components/paginateTable.vue';
import { getDashboardMetricsSpecific } from '@/requests/ac';

export default {
  components:{paginateTable},
  props:{
    preFilters:{},
    table_type:{},
	},
  data() {
    return {
      pwo_type_header: {
        Overdue:[{ text: 'No. of unfinished PM02 Overdue (Weekly)', sortable: false, value: 'pwo_with_detail'}],
        Cancelled:[{ text: 'Number of preventive Work Orders  cancelled (Weekly)', sortable: false, value: 'pwo_with_detail'}],
        Compliance:[{ text: 'Finished PM02 Work Orders within  Tolerance', sortable: false, value: 'pwo_with_detail'}],
      },
      pwo_type_header_extra: {
        Overdue:[{ text: 'No. of unfinished PM02 (Weekly)', sortable: false, value: 'pwo_total'}],
        Cancelled:[{ text: 'Number of preventive Work Orders  completed (Weekly)', sortable: false, value: 'pwo_total'}],
        Compliance:[{ text: 'Finished PM02 Work Orders', sortable: false, value: 'pwo_total'}],
      }
    };
  },
  computed: {
    get(){ return getDashboardMetricsSpecific},
    headers() {
      let list = [
        { text: 'Operation', sortable: false, value: 'organization_name'},
        { text: 'Functional  Location', sortable: false, value: 'functional_location'},
        { text: 'Descripción', sortable: false, value: 'dsc'},
      ];
      if (this.table_type == 'ReportTable') {
        list = list.concat([
          { text: 'Main Work Centre', sortable: false, value: 'main_group_centre'},
          { text: 'Nro de Orden', sortable: false, value: 'work_order_number'},
          { text: 'Desc Orden', sortable: false, value: 'wo_description'},
        ]);
      }
 
      if (this.preFilters.pwo_type && this.table_type != 'ReportTable') {
        list = list.concat(this.pwo_type_header[this.preFilters.pwo_type]);
        list = this.preFilters.pwo_time ? list.concat(this.pwo_type_header_extra[this.preFilters.pwo_type]): list;
      }
      return list
      
    },
  },
  methods: {
    findV(key){ return this.headers.find(h => h.value === key) },
  }, // methods
};
</script>
